import React from 'react';
import styles from './styles.scss';

const Boss = () => (
  <span className={styles.boss}>BOSS</span>
);

export default Boss;
